import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import { TranslateItemSelect } from '../../../common/html/text/TranslateItem'
import { PopupCopyOrMoveCompany } from '../../../common/popup/PopupCopyOrMoveCompany'
import { checkIsSelectAll, getListIdSelectByObj } from '../../../helper'
import { TYPE_POPUP_MOVE_COPY } from '../../../savedPortfolios/detailsPortfolios/constant'
import { postCopyCompany } from '../../../savedPortfolios/detailsPortfolios/store/thunk'
import classes from '../index.module.scss'
import {
  selectAllIdByTerm,
  selectDataCheckBox,
  unSelectAllCheckbox,
} from '../store/slice'

export const InteractiveTable = () => {
  const dispatch = useDispatch()

  const checkboxObj = useSelector(selectDataCheckBox('listIdsSelected'))
  const listIdAllByTerm = useSelector(selectDataCheckBox('listIdAllByTerm'))

  const isShowInteractive = Object.values(checkboxObj).some(Boolean)
  const numberIdSelected = Object.values(checkboxObj).reduce(
    (accumulator, currentValue) =>
      currentValue ? accumulator + currentValue : accumulator,
    0,
  )
  const isSelectAllIdByTerm = checkIsSelectAll(listIdAllByTerm, checkboxObj)

  const [isShowCopy, setShowCopy] = useState(false)

  const handleCopy = () => {
    setShowCopy(true)
  }

  const handleSelectAllPortfolio = (value) => {
    dispatch(selectAllIdByTerm(value))
  }

  const handleUnSelectAllPortfolio = () => {
    dispatch(unSelectAllCheckbox())
  }

  const onSubmitCopy = (listPort) => {
    dispatch(
      postCopyCompany({
        organizationIds: [...getListIdSelectByObj(checkboxObj)],
        targetPorfolioIds: [...listPort],
      }),
    )
      .unwrap()
      .then(() => {
        handleUnSelectAllPortfolio()
        setShowCopy(false)
      })
      .catch(() => {})
  }

  return (
    <>
      {isShowInteractive && (
        <Element
          className={['dFlex alignItemsCenter', classes.listActionIcon].join(
            ' ',
          )}
        >
          {isShowInteractive && (
            <>
              <Element
                elementName="p"
                style={{ lineHeight: '16px', fontWeight: 600 }}
              >
                <TranslateItemSelect count={numberIdSelected} />
              </Element>
              {isSelectAllIdByTerm ? (
                <Element
                  elementName="p"
                  style={{
                    lineHeight: '16px',
                    fontWeight: 600,
                    color: '#2C73E8',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleUnSelectAllPortfolio()}
                >
                  <Translate value="library.main.UNSELECT_ALL" />
                </Element>
              ) : (
                <Element
                  elementName="p"
                  style={{
                    lineHeight: '16px',
                    fontWeight: 600,
                    color: '#2C73E8',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleSelectAllPortfolio(true)}
                >
                  <Translate
                    value="library.main.SELECT_ALL"
                    count={listIdAllByTerm?.length}
                  />
                </Element>
              )}
              <>
                <Tooltip isI18n tooltipContent="library.main.COPY">
                  <Element
                    className={classes.icon}
                    style={{ backgroundColor: '#f2f7ff' }}
                    onClick={handleCopy}
                  >
                    <Icon
                      style={{ color: '#FFCB1E', fontSize: 16 }}
                      className="icon-folder-plus"
                    />
                  </Element>
                </Tooltip>
              </>
            </>
          )}
        </Element>
      )}
      {isShowCopy && (
        <PopupCopyOrMoveCompany
          isShow={isShowCopy}
          setShow={setShowCopy}
          type={TYPE_POPUP_MOVE_COPY.COPY}
          handleApply={onSubmitCopy}
          numberCompany={[...getListIdSelectByObj(checkboxObj)].length}
        />
      )}
    </>
  )
}
